module.exports = __webpack_public_path__ + "img/E0000_18.e560a80c.svg";